define("shared/utils/can-create-linkinbio-page", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  /**
   * Given a subscription and current account's number of linkinbio pages, returns true if the account can add another linkinbio page
   */

  const canCreateLinkinbioPage = (numberOfAllowedLinkinbioPages, linkinbioPagesCount, isAdmin) => {
    return linkinbioPagesCount < numberOfAllowedLinkinbioPages || isAdmin;
  };
  var _default = _exports.default = canCreateLinkinbioPage;
});